import { addMinutes, closestTo, isWithinInterval } from 'date-fns';
import * as R from 'ramda';

// only to new date
export const dateWithoutTZ = (date) =>
  addMinutes(date, date.getTimezoneOffset());

export const getDateInTheRange = (boundaries) => (date) => {
  if (R.isNil(boundaries)) return boundaries;
  if (R.includes(undefined, boundaries)) return undefined;
  if (R.isNil(date) || R.isEmpty(boundaries)) return date;
  const [start, end] = boundaries;
  return isWithinInterval(new Date(date), {
    start: new Date(start),
    end: new Date(end),
  })
    ? date
    : closestTo(new Date(date), [new Date(start), new Date(end)]);
};
